// extracted by css-extract-rspack-plugin
var _1 = "admin-table-NwBVmO";
var _2 = "admin-table-NwBVmO";
var _3 = "column-name-Fq00JQ";
var _4 = "column-name-Fq00JQ";
var _5 = "table-gDI563";
export { _1 as "admin-table", _2 as "adminTable", _3 as "column-name", _4 as "columnName", _5 as "table" }
